import React, { useState, useEffect } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "../../FixedAssetReport/ManageUser/ProvincalUser.module.css";
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { Spinner, Badge, Button, Modal, OverlayTrigger, Tooltip, Form, Row, Col, Container, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from "../../FixedAssetReport/AdminNav/FixedAdminNav";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import {  FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"
import { BASE_URL, BASE_URL1, TOKEN } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { FaEye, FaRegTrashAlt} from "react-icons/fa";





const FixedContinent = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [show1, setShow1] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [file, setFile] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState();
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState();
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState();
  const [phone, setPhone] = useState();
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const navigate = useNavigate();
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [benLoading, setBenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [role, setRole] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [createLoading, setCreateLoading] = useState(false);

  // const [selectType, setSelectType] = useState(userData?.type || "");
  // const [selectedProvince, setSelectedProvince] = useState(userData?.province_id || "");
  const [selectedProvince, setSelectedProvince] = useState();
  const [selectType, setSelectType] = useState("");
  const [userType, setUserType] = useState([]);
  const [continents, setContinents] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [tableData5, setTableData5] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [subContloading, setSubContLoading] = useState(false);
  const [subRegloading, setSubRegLoading] = useState(false);
  const [admin, setAdmin] = useState("");
  const [selectedContinent, setSelectedContinent] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedZone1, setSelectedZone1] = useState('');
  const [description, setDescription] = useState('');
  const [description1, setDescription1] = useState('');
  const [eyeClicked, setEyeClicked] = useState(false);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [zones, setZones] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);
  const [areaLoad, setAreaLoad] = useState(false);
  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value3 = await localStorage.getItem('admin');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');

      if (value !== null) {

        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }

      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  

  const handleClose1 = () => setShow1(false);

const handleShow1 = (item) => {
  setSuppliers(item)
  setFullName1(item.name || "");
  setEmail1(item.email || "");
  setAddress1(item.address || "");
  setPhoneNo(item.phone_number || "");
  setSelectedContinent(item.continent.description || "");
  setSelectedRegion(item.region.description || "");
  setSelectedProvince(item.province.description || "");
  setShow1(true);
};



// const fetchSearch = async (searchTerm) => {
//   setSearchLoading(true);
//   try {
//     let res;
//     if (searchTerm.trim() === "") {
//       res = tableData1;
//     } else {
//       const response = await axios.get(`${BASE_URL}/users/search`, {
//         params: { variable: searchTerm },
//         headers
//       });
//       res = response.data?.data;
//     }
//     setSearchedResult(res);
//     console.log(res);

//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       navigate('/login');
//     } else {
//       let errorMessage = 'An error occurred. Please try again.';
//       if (error.response && error.response.data && error.response.data.message) {
//         if (typeof error.response.data.message === 'string') {
//           errorMessage = error.response.data.message;
//         } else if (Array.isArray(error.response.data.message)) {
//           errorMessage = error.response.data.message.join('; ');
//         } else if (typeof error.response.data.message === 'object') {
//           errorMessage = JSON.stringify(error.response.data.message);
//         }
//         console.log(error);
//       }
//       setSearchedResult([]);
//     }
//   } finally {
//     setSearchLoading(false);
//   }
// };


// useEffect(() => {
//   fetchSearch(searchTerm);
// }, [searchTerm]);




const handleShow = () => setShow(true);
const handleClose = () => setShow(false);

    // const handleChange = (option) => {
    //         setSelectedOption(option);
    //         console.log("Selected:", option);
    //     };
    function getLoanColors(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 90%)`, 
    color: `hsl(${hue}, 70%, 30%)`,   
  };
}


  const [rows, setRows] = useState([{ bankName: "", accName: "", accNo: "" }]);

  const addRow = () =>
    setRows([...rows, { bankName: "", accName: "", accNo: "" }]);

  const deleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

const handleUploadShow = () => setUploadShow(true);
const handleUploadClose = () => {
  setUploadShow(false);
  setFile(null);
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  setFile(file);
};



function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

const fetchData1 = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
    const typeList = response.data?.data;
    console.log("lists:", typeList);
    setUserType(typeList);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    }
  } finally {
    setIsLoading(false);
  }
};
const isAllowedUserType = (userType) => {
  const blocked = ['1', '7', '8'];
  return userType && !blocked.includes(userType);
};


const fetchContinents = async () => {
  setContLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/continents`, { headers });
    const contList = response.data?.data;
    // console.log("continents:", contList);
    setContinents(contList);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    }
  } finally {
    setContLoading(false);
  }
};

const fetchSubContinents = async (selectedContinent) => {
  setSubContLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/regions`, { headers });
    // console.log(response);
    const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
    setTableData4(options1);
    console.log(subCont, "heeeer");
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setTableData4([]);
  } finally {
    setSubContLoading(false);
  }
};

useEffect(() => {
  if (bearer && selectedContinent) {
    fetchSubContinents(selectedContinent);
  }
}, [bearer, selectedContinent]);

const fetchSubRegion = async (selectedRegion) => {
  setSubRegLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/provinces`, { headers });
    // console.log(response);
     const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
    setTableData5(options25);
    // console.log(subReg, "heeeer");
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    setTableData5([]);
  } finally {
    setSubRegLoading(false);
  }
};

useEffect(() => {
  if (bearer && selectedRegion) {
    fetchSubRegion(selectedRegion);
  }
}, [bearer, selectedRegion]);



useEffect(() => {
  if (bearer) {
    fetchData1();
    fetchContinents();
  }
}, [bearer]);


const updateBeneficiary = async () => {

  setUploadLoading(true);
  try {
    const bankAccounts = rows.map(item => item.accNo);
    const accountNames = rows.map(item => item.accName);
    const bankNames = rows.map(item => item.bankName);

    const response = await axios.post(`${BASE_URL}/beneficiaryaccounts/update`,
      {
        name: fullName1,
        email: email1,  
        phone_number: phoneNo,
        address: address1,
        bank_account: bankAccounts,
        account_name: accountNames,
        bank_name: bankNames,
        id: suppliers.id
       
      },
      { headers }
    );
    handleClose1();
    // FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    })
    // .then(() => {
    //   window.location.reload();
    // });
    console.log(response.data.message)
    setUploadLoading(false);
} catch (error) {
  let errorMessage = error.response?.data?.message;
  // let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log("error", errorMessage);
          }
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: errorMessage,
          });
      }
  } finally {
    setUploadLoading(false);
  }
};

const uploadExcelHandler = async () => {
  if (!file) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Please select a file to upload',
    });
    return;
  }

    // Confirmation alert before upload
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this file?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel",
    });
  
    if (!result.isConfirmed) {
      handleUploadClose(); 
      return; 
    }

  setUploadLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${BASE_URL}/beneficiary/upload`, 
      formData, 
      { headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        } });

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message || 'File uploaded successfully',
    });
    window.location.reload();

    handleUploadClose();
    setFile("");
  } catch (error) {
    let errorMessage;

    if (error.response && error.response.data) {
      errorMessage = typeof error.response.data.message === 'object'
        ? JSON.stringify(error.response.data.message)
        : error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unexpected error occurred while uploading the file';
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setUploadLoading(false);
  }
};

const createBeneficiary = async () => {
  setLoading(true);
  try {
    const response = await axios.post(`${BASE_URL}/beneficiary/add`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankName,
        account_name: accName,
        account_number: accNo
      },
      { headers }
    );
    console.log(response.data.message);
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    // FetchSuppliers();
    handleClose();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data.message);

  } catch (error) {
    let errorMessage;

    // Attempt to extract the error message
    if (error.response && error.response.data) {
      // If message is an object, attempt to stringify it
      if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      } else {
        errorMessage = error.response.data.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "An unexpected error occurred";
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setLoading(false);
  }
};


const fetchAllZones = async (provinceID) => {
  setProvLoading(true);
  try {
    const response = await axios.get(
      `${BASE_URL1}/provinces/getzonesprovince?province_id=${provinceID}`,
      {
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      }
    );

    const zoneList = response.data?.data || [];
    const formatted = zoneList.map((item) => ({
      label: item.description,
      value: item.id,
    }));

    setZones(formatted);

    // 🚀 After zones load, fetch areas for the first zone
    if (formatted.length > 0) {
      fetchData(formatted[0].label);
    }

  } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setZones([]);
      } finally {
    setProvLoading(false);
  }
};

const fetchData = async () => {
  setBenLoading(true);
  try {
    const response = await axios.get(`${BASE_URL1}/continents`, {
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
      },
    });

    const results = response.data?.data;
    setTableData(results);
    console.log(results);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData([]);
    }
  } finally {
    setBenLoading(false);
  }
};


// useEffect(() => {
//   if (bearer && provinceID) {
//     fetchAllZones(provinceID);
//   }
// }, [TOKEN, provinceID]);

useEffect(() => {
  if (TOKEN) {
    fetchData();
  }
}, [TOKEN]);

// const fetchAreas = async () => {
//   setIsLoading(true);
//   try {
//     const response = await axios.get(
//       `${BASE_URL1}/provinces/getaparishprovince`,
//       {
//         headers: {
//           Authorization: `Bearer ${TOKEN}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     const results = response.data?.data;
//     console.log(results);
//     setTableData(results);

//     // const resultx = response.data?.data?.parishes?.total;
//     // setTotalEntries(resultx);

//     // const total = response.data?.data?.parishes?.last_page || 1;
//     // setTotalPages(total);

//     // Transform the API response to match the expected { value, label } format
//     const formattedOptions =
//       results?.map((item) => ({
//         value: item.id, // Adjust based on API response structure
//         label: item.description, // Adjust based on API response structure
//       })) || [];

//     setOptions(formattedOptions);
//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       // Redirect to login page if unauthorized
//       // navigate('/login');
//     } else {
//       let errorMessage = "An error occurred. Please try again.";
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message
//       ) {
//         if (typeof error.response.data.message === "string") {
//           errorMessage = error.response.data.message;
//         } else if (Array.isArray(error.response.data.message)) {
//           errorMessage = error.response.data.message.join("; ");
//         } else if (typeof error.response.data.message === "object") {
//           errorMessage = JSON.stringify(error.response.data.message);
//         }
//       }
//       setTableData([]);
//     }
//     console.log(error);
//   } finally {
//     setIsLoading(false);
//   }
// };

// useEffect(() => {
//   if (TOKEN) {
//     fetchAreas();
//   }
// }, [TOKEN]);

const handleContinentChange = (event) => {
  setSelectedContinent(event.target.value);
  setSelectedRegion('');
  setSelectedProvince('');
};

const handleRegionChange = (event) => {
  setSelectedRegion(event.target.value);
};

const handleProvinceChange = (event) => {
  setSelectedProvince(event.target.value);
};

const createUser = async () => {
  if (!selectedRole) {
    // toast.error("Please select a role.");
    return; // Stop submission if role is not selected
  }

  setCreateLoading(true);
  try {
    const payload = {
      name: fullName,
      email: email,
      phone_number: phone,
      type: selectedRole,
      // parishId
    };

    const response = await axios.post(
      `${BASE_URL1}/user/create-province-users`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response);

    // navigate(-1);
    setFullName("");
    setPhone("");
    setEmail("");
    // setSelectType("");
    setSelectedRole("");
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data);
  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
      // toast.error(JSON.stringify(error.response.data.message));
    }
    console.log(error);
  } finally {
    setCreateLoading(false);
  }
};
const createContinent = async () => {
  setCreateLoading(true);
  try {
    const response = await axios.post(
      `${BASE_URL1}/continents/create_continent`,
      {
        description: description,
      },
      {
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
        }
      }
    );

    fetchData();
    setDescription('');
    handleClose();
    
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
      console.log(errorMessage);
    }
  } finally {
    setCreateLoading(false);
  }
};


const handleSelectChange = (event) => {
  setSelectedRole(event.target.value); // Update state with selected value
};

const startIndexx = (currentPage - 1) * entriesPerPage + 1;
// const filteredData = searchTerm.trim() ? searchedResult : tableData;

const rowss = Array.isArray(tableData) ? tableData : [];

const filteredData = rowss.filter(item => {
  const term = searchTerm.toLowerCase();
  return (
    item.description?.toLowerCase().includes(term) ||
    formatDate(item.created_at)?.toLowerCase().includes(term) ||  // Use your formatDate helper
    formatDate(item.updated_at)?.toLowerCase().includes(term)
  );
});

const handleTrashClick = async (id) => {
  const confirmResult = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this continent. This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  });

  if (confirmResult.isConfirmed) {
    try {
      const response = await axios.get(`${BASE_URL1}/continents/delete_continent?id=${id}`, {
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
        },
      });
      fetchData();
      
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: errorMessage,
        });
      }
    }
  } else {
    Swal.fire({
      icon: 'info',
      title: 'Cancelled',
      text: 'The deletion was cancelled.',
    });
  }
};

const handleEyeClick = (id) => {
  const foundZone = tableData.find(item => item.id === id);
  setSelectedZone1(id);
  setDescription1(foundZone?.description || '');
  setShow1(true);
  setEyeClicked(true);
};

const editContinent = async () => {
  setCreateLoading(true);

  try {
    const response = await axios.post(
      `${BASE_URL1}/continents/update_continent`,
      {
        description: description1,
        id: selectedZone1
      },
      {
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
        },
      }
    );

    fetchData();
    handleClose1();
    
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  } finally {
    setCreateLoading(false);
  }
};

const totalEntries = filteredData.length;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
const totalPages = Math.ceil(filteredData.length / entriesPerPage);
const formattedTotalEntries = totalEntries.toLocaleString();

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};


const handleTypeChange = (e) => setSelectType(e.target.value);




        
  return (
    <div >
        <HeaderNav />
      
    
<Modal show={show1} onHide={handleClose1} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update Continent</Modal.Title>
  </Modal.Header>
  <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Description"
                              // autoFocus
                              value={description1}
                              onChange={(e) => setDescription1(e.target.value)}
                            />
                            
                          </Form.Group>
                        </Form>
                      </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button variant="primary" 
                                   className={classes.createUserButton}
                                onClick={editContinent} >
                                  {createLoading ? ( <> <Spinner  size='sm' />
                                    <span style={{ marginLeft: '5px' }}>
                                      Editing Continent, Please wait...
                                    </span>
                                    </>) : ("Save Changes")}
                                </Button>

  </Modal.Footer>
</Modal>

<Modal show={uploadShow} onHide={handleUploadClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Excel File</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{padding: 0}}>
                <Form style={{ marginTop: 5 }}>
               
                  <Form.Group style={{padding: 10,}}>
                  {/* <button  className={classes.customButton1} >
                  <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                  <img src={download} alt="download" /> Download Template
                    </a>
                </button> */}
                </Form.Group>
                  {/* <hr className={classes.downline} /> */}


                  <Form.Group style={{padding: 10}} className="mb-3" controlId="exampleForm.ControlInput2">
                    <Form.Label>Select Excel File</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                    <div style={{ marginTop: 10 }} />
                  </Form.Group>

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleUploadClose}>
                  Go back
                </Button>
                <Button  className={classes.customButton}  onClick={uploadExcelHandler}>
                  Upload File
                </Button>
              
              </Modal.Footer>
            </Modal>
            {/* {uploadLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )} */}

            <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Add Continent</Modal.Title>
          </Modal.Header>
          <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Description"
                              // autoFocus
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                            
                          </Form.Group>
                        </Form>
                      </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Cancel
            </Button>
            <Button className={classes.customButton} onClick={createContinent}>
            {createLoading ? (
                    <>
                      <Spinner size="sm" />
                      <span style={{ marginLeft: "5px" }}>
                        "Creating continent, Please wait..."
                      </span>
                    </>
                  ) : (
                    "Add Continent"
                  )}
              
            </Button>
          </Modal.Footer>
        </Modal>
        {loading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          {/* <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Supplier's Payment</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div> */}
          <div style={{}} className={classes.headtxt}>
            <h3 className={classes.topText}>Manage Continent</h3>
            <p className={classes.prgText}>Add, View, Edit and Delete Continents.</p>
            </div>

            <div className={classes.subContainer}>            
            <div className={classes.laysbtns}>
                            <button className={classes.loanBtn} 
                            onClick={handleShow}
                            >
                              <img src={plus} alt="plus" /> 
                              Add Continent
                            </button>
                            {/* <button className={classes.loanBtn} 
                          onClick={handleUploadShow}
                          >
                            Upload Excel
                          </button> */}

                            {/* <button  className={classes.customButton1} >
                            <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                            <img src={download} alt="download" /> Download Template
                              </a>
                          </button>  */}
                          </div>

                          {/* <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Total Users</p>
                              <p className={classes.txtHds}>{formattedTotalEntries}</p>
                              </div>
                            </div> */}

                         <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search Continent..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>

            </div>
            
            <div className={classes.tableContainer}>
            
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
                             <tr>
                              {/* <th>S/N</th> */}
                              <th>#</th>
                              <th>Continent</th>
                                      <th>Created At</th>
                                      <th>Updated At</th>
                                      <th>Actions</th>
                            </tr>
  </thead>
  <tbody>

  { benLoading ? (
    searchTerm ? (
      <tr>
        <td colSpan={5} style={{ textAlign: "center" }}>
          Fetching Continent...
        </td>
      </tr>
    ) : (
      Array(3).fill().map((_, idx) => (
        <tr key={idx}>
          {Array(5).fill().map((_, i) => (
            <td key={i}>
              <Skeleton height={20} style={{ marginBottom: 10 }} />
            </td>
          ))}
        </tr>
      ))
    )
  ) : (
    displayedData.map((item, index) => (

      <tr key={index}>
                                              <td className={classes.textby} style={{paddingLeft: 10}}>{index + 1}</td>
                                              <td className={classes.textby} style={{paddingLeft: 10}}>{item.description}</td>
                                              <td className={classes.textby} style={{paddingLeft: 10}}>{formatDate(item.created_at)}</td>
                                              <td className={classes.textby} style={{paddingLeft: 10}}>{formatDate(item.updated_at)}</td>
                                              <td style={{display: "flex", gap: "10px"}}>
                                                <div style={{cursor: "pointer"}} 
                                                onClick={() => handleEyeClick(item.id)} >
                                                <img src={EyeIcon} />
                                                </div>
                                                <div
                                                style={{cursor: "pointer"}}
                                                 onClick={() => handleTrashClick(item.id)} >
                                                <img src={DeleteIcon} />
                                                </div>
                                              </td>
                                            </tr>
    ))
  )
}
  </tbody>

  {!benLoading && displayedData.length === 0 && (
  <tbody>
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}>
        No data found
      </td>
    </tr>
  </tbody>
)}

</table>

{!benLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default FixedContinent;


      // <tr key={index}>
      //   <td className={classes.textby}>{index + 1}</td>
      //   <td className={classes.textby}>{item.name}</td>
      //   <td className={classes.textby}>{item.email}</td>
      //   <td className={classes.textby}>{item.phone_number}</td>
      //   <td className={classes.btnAction}>
      //     <button
      //       style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
      //       onClick={() => handleShow1(item)} 
      //     >
      //       <img src={EyeIcon} />
      //     </button>

      //     <button
      //       onClick={() => handleTrashClick(item.id)}
      //       style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
      //     >
      //       <img src={DeleteIcon} />
      //     </button>
      //   </td>
      // </tr>